import moment from "moment";
import { ModelBase } from "../../abstract/model-base.model";
import { Partner } from "../../partner/partner.model";
import { SalesInvoice } from "../invoice/sales-invoice.model";
import { RecurringInvoiceEndingMode } from "./ending-mode.model";
import { File } from "../../file/file.model";
import { PartnerContact } from "../../partner/contact.model";
import { Frequency } from "../../core/frequency.model";
import { StatusEnum } from "src/app/@shared/enums/status.enum";

export class RecurringInvoice extends ModelBase {

    static override CLASS_NAME: string = 'RecurringInvoice';

    private _endDate!: moment.Moment;
    private _endingMode!: RecurringInvoiceEndingMode;
    private _emailAttachments!: File[];
    private _emailBody!: string;
    private _emailInvoice!: boolean;
    private _emailSubject!: string;
    private _emailToExternal!: PartnerContact[];
    private _frequency!: Frequency;
    private _invoice!: SalesInvoice;
    private _label!: string;
    private _lastGenerationDate!: moment.Moment;
    private _maxOccurrences!: number;
    private _nextGenerationDate!: moment.Moment;
    private _partner!: Partner;
    private _startDate!: moment.Moment;
    private _validateInvoice!: boolean;

    public static statusLabel(status: string): string {
        switch (true) {
            case (status === 'active'):
                return 'Active';
            case (status === 'inactive'):
                return 'Inactive';
            case (status === 'completed'):
                return 'Complétée';
            default:
                return 'Inconnu';
        }
    }

    public static statusSeverity(status: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined {
        switch (true) {
            case (status === 'active'):
                return 'success';
            case (status === 'inactive'):
                return 'secondary';
            case (status === 'completed'):
                return undefined;
            default:
                return 'warn';
        }
    }

    constructor(data: any) {
        super(data);
        this._emailAttachments = this._emailAttachments || [];
        this._emailToExternal = this._emailToExternal || [];
    }

    public get endDate(): moment.Moment {
        return this._endDate;
    }

    public set endDate(value: any) {
        this._setValue('_endDate', value, 'date');
    }

    public get endingMode(): RecurringInvoiceEndingMode {
        return this._endingMode;
    }

    public set endingMode(value: any) {
        this._setValue('_endingMode', value, 'RecurringInvoiceEndingMode');
    }

    public get emailAttachments(): File[] {
        return this._emailAttachments;
    }

    public set emailAttachments(value: any) {
        this._setValue('_emailAttachments', value, 'File');
    }

    public get emailBody(): string {
        return this._emailBody;
    }

    public set emailBody(value: any) {
        this._setValue('_emailBody', value, 'string');
    }

    public get emailInvoice(): boolean {
        return this._emailInvoice;
    }

    public set emailInvoice(value: any) {
        this._setValue('_emailInvoice', value, 'boolean');
    }

    public get emailSubject(): string {
        return this._emailSubject;
    }

    public set emailSubject(value: any) {
        this._setValue('_emailSubject', value, 'string');
    }

    public get emailToExternal(): PartnerContact[] {
        return this._emailToExternal;
    }

    public set emailToExternal(value: any) {
        this._setValue('_emailToExternal', value, 'PartnerContact');
    }

    public get frequency(): Frequency {
        return this._frequency;
    }

    public set frequency(value: any) {
        this._setValue('_frequency', value, 'Frequency');
    }

    public get invoice(): SalesInvoice {
        return this._invoice;
    }

    public set invoice(value: any) {
        this._setValue('_invoice', value, 'SalesInvoice');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get lastGenerationDate(): moment.Moment {
        return this._lastGenerationDate;
    }

    public set lastGenerationDate(value: any) {
        this._setValue('_lastGenerationDate', value, 'date');
    }

    public get maxOccurrences(): number {
        return this._maxOccurrences;
    }

    public set maxOccurrences(value: any) {
        this._setValue('_maxOccurrences', value, 'integer');
    }

    public get nextGenerationDate(): moment.Moment {
        return this._nextGenerationDate;
    }

    public set nextGenerationDate(value: any) {
        this._setValue('_nextGenerationDate', value, 'date');
    }

    public get partner(): Partner {
        return this._partner;
    }

    public set partner(value: any) {
        this._setValue('_partner', value, 'Partner');
    }

    public get startDate(): moment.Moment {
        return this._startDate;
    }

    public set startDate(value: any) {
        this._setValue('_startDate', value, 'date');
    }

    public get statusLabel(): string {
        switch (true) {
            case (this.hasStatus(StatusEnum.Active)):
                return RecurringInvoice.statusLabel(StatusEnum.Active);
            case (this.hasStatus(StatusEnum.Inactive)):
                return RecurringInvoice.statusLabel(StatusEnum.Inactive);
            case (this.hasStatus(StatusEnum.Completed)):
                return RecurringInvoice.statusLabel(StatusEnum.Completed);
            default:
                return RecurringInvoice.statusLabel('unknown');
        }
    }

    public get statusSeverity(): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined {
        switch (true) {
            case (this.hasStatus(StatusEnum.Active)):
                return RecurringInvoice.statusSeverity(StatusEnum.Active);
            case (this.hasStatus(StatusEnum.Inactive)):
                return RecurringInvoice.statusSeverity(StatusEnum.Inactive);
            case (this.hasStatus(StatusEnum.Completed)):
                return RecurringInvoice.statusSeverity(StatusEnum.Completed);
            default:
                return RecurringInvoice.statusSeverity('unknown');
        }
    }

    public get validateInvoice(): boolean {
        return this._validateInvoice;
    }

    public set validateInvoice(value: any) {
        this._setValue('_validateInvoice', value, 'boolean');
    }

}